import{clsx as r}from"clsx";import{twMerge as t}from"tailwind-merge";function o(...e){return t(r(e))}export{o as a};
